import Vue from 'vue'
import Vuex from 'vuex'
import pkg from 'package'
import * as actions from './actions'
import * as getters from './getters'

import app from './modules/app'
import menu from './modules/menu'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,  // process.env.NODE_ENV !== 'production',
  actions,
  getters,
  modules: {
    app,
    menu
  },
  mutations: {
    setLoadedScenario(state, payload) {
      state.loadedScenario = payload
    },
    SET_AUTHENTICATION_TOKEN(state, token) {
      state.authenticationToken = token
    },
    SET_LOGGED_ROLE(state, role) {
      state.loggedRole = role
    },
    SET_LOGGED_USER(state, user) {
      state.loggedUser = user
    },
    SET_LOGGED_USER_STATE(state, userstate) {
      state.loggedUserState = userstate
    },
    SET_LOGGED_STATUS(state, status) {
      state.isLogged = status
    },
    SET_LOGGED_ID(state, id) {
      state.loggedId = id
    },
    SET_PERMISSION_MAP(state, map) {
      state.permissionMap = map
    },
    SET_CLIENT_ID(state, clientid) {
      state.clientId = clientid
    }
  },
  state: {
    isLogged: localStorage.getItem('authenticationToken') !== null,
    authenticationToken: localStorage.getItem('authenticationToken'),
    loggedUser: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('loggedUser') : '',
    loggedUserState: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('loggedUserState') : '',
    loggedRole: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('loggedRole') : 16,
    loggedId: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('loggedId') : null,
    loadedScenario: {},
    permissionMap: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('permissionMap') : null,
    clientId: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('clientId') : null,
    pkg
  }
})

export default store



// WEBPACK FOOTER //
// ./client/store/index.js